import StandAdmin from './StandAdmin';
export default StandAdmin;
